module.exports = __webpack_public_path__ + "static/apple-mobile-alt-862842423e10721d8fadb9a9020f1877.png";